import { CustomerPlanEnum } from "@resource/common";
import withPageAuthRequired from "auth/withPageAuthRequired";
import ContentTemplates from "components/ContentTemplates";
import Layout from "components/Layout";
import TemplatesLayout from "components/TemplatesLayout";
import { ReactElement } from "react";
import { PermissionEnum } from "utils/permissions";

export default withPageAuthRequired(ContentTemplates, {
  requiredPlan: CustomerPlanEnum.Platform,
  requiredPermissions: PermissionEnum.TEMPLATE_READ,
  getLayout: (page: ReactElement) => (
    <Layout>
      <TemplatesLayout>{page}</TemplatesLayout>
    </Layout>
  ),
});
